module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_mit-c85ec9532d2408bf8fe9feaf8fe3d806.png";